import { sharedFr } from '@/shared/core/locales/shared.fr.ts'
import { devinoFr } from '@/teams/devino/locales/devino.fr.ts'
import { portfolioFr } from '@/teams/portfolio/locales/portfolio.fr.ts'

export const fr = {
	translation: {
		...sharedFr,
		...devinoFr,
		...portfolioFr,
	},
}
